module.exports = __webpack_public_path__ + "img/product-placeholder-52.356f795.png";